import * as React from "react";
import type { SVGProps } from "react";
const SvgCalendarChartAnalytics = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.5 3v3M16.5 3v3M9 21H6a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3V9"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16 21a5 5 0 1 1 0-10 5 5 0 0 1 0 10M16 16v-5M19.535 19.535 16 16"
    />
  </svg>
);
export default SvgCalendarChartAnalytics;
